import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { MonetaryAmount } from '../../../types/__generated__';
import { makePhotoUrlFromAbsoluteUrl } from '../../utils/makePhotoUrl';
import Avatar from '@justgiving/avatar';
import classnames from 'classnames';
import TimestampWrapper from '../TimestampWrapper/TimestampWrapper';
import parseCurrency from '../../utils/parseCurrency';
import styles from './SupporterCard.scss';
import { SIZE_136_136 } from '../../constants/imageTemplateStrings';
import '@justgiving/loading/src/Loading.scss';

type SupporterCardProps = {
  avatarImageUrl?: string;
  displayName?: string;
  creationDate: string;
  message?: string;
  amount?: MonetaryAmount;
  giftAidAmount?: MonetaryAmount;
};

export const SupporterCard: FunctionComponent<SupporterCardProps> = ({
  avatarImageUrl,
  displayName,
  creationDate,
  message,
  amount,
  giftAidAmount,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  return (
    <li data-qa="supporter-card" className={styles.card}>
      <Avatar
        avatarSize="large"
        picture={
          (avatarImageUrl &&
            makePhotoUrlFromAbsoluteUrl(avatarImageUrl, SIZE_136_136)) ||
          undefined
        }
      />
      <div className={classnames(styles.card_content, 'jg-space-pbmd')}>
        <div
          className={classnames(
            styles.card_name_and_date_wrapper,
            'jg-space-mtxs',
          )}
        >
          <span className={'jg-h5'}>
            {displayName ?? t('common.anonymous')}
          </span>
          <span className={'jg-text--small-light'}>
            <TimestampWrapper date={creationDate} />
          </span>
        </div>
        <p className={classnames('jg-space-mtn', 'jg-text--light')}>
          {message}
        </p>
        {amount && (
          <p
            className={classnames(
              'jg-text--brand',
              'jg-text-color-branded',
              'jg-space-mbn',
            )}
          >
            {parseCurrency(amount.currencyCode, amount.value / 100)}
            {giftAidAmount && (
              <span
                className={classnames(
                  'jg-text--brand-small',
                  'jg-text-color-branded',
                )}
              >
                {` + `}
                {parseCurrency(
                  giftAidAmount.currencyCode,
                  giftAidAmount.value / 100,
                )}{' '}
                {t('common.giftaid')}
              </span>
            )}
          </p>
        )}
      </div>
    </li>
  );
};
